module.exports = __webpack_public_path__ + "static/icono-mantenimiento-over-92df5b2581c7a35097a80ac3b1e67ddb.png";